import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-bone mt-24"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-6">
            <Logo size={32} invert />
            <p className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight mt-10 max-w-[16ch]">
              Chemistry of the <em className="not-italic text-oxred">next</em> nervous system.
            </p>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-tight text-[10px] text-bone/50 block mb-6">Sitemap</span>
            <ul className="space-y-3 font-mono-tight text-[12px]">
              <li><Link to="/" data-testid="footer-link-home" className="link-underline">Index</Link></li>
              <li><Link to="/what-we-do" data-testid="footer-link-wwd" className="link-underline">What We Do</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="link-underline">About</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="link-underline">Contact</Link></li>
              <li><Link to="/press" data-testid="footer-link-press" className="link-underline">Press &amp; Media</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-tight text-[10px] text-bone/50 block mb-6">Registered Office</span>
            <address className="not-italic font-sans text-sm leading-relaxed text-bone/85">
              NewGenPharma AG<br />
              Baarerstrasse 78<br />
              CH-6300 Zug, Switzerland
            </address>
            <p className="mt-6 font-mono-tight text-[10px] text-bone/50">
              CHE-489.221.804 · Swissmedic Reg. Pending
            </p>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-bone/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-mono-tight text-[10px] text-bone/50">
            © {year} NewGenPharma AG · All research assets referenced are illustrative and pre-clinical.
          </p>
          <div className="flex items-center gap-6 font-mono-tight text-[10px] text-bone/50">
            <span>GMP-aligned intermediates</span>
            <span className="w-1 h-1 bg-oxred inline-block" />
            <span>Est. 2023</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
